// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1p8dglyw button:not(#local-media-upload-button):not([disabled]):after{border:none}\n._89rs1b66 div[role=group]{gap:var(--ds-space-050,4px)}\n._zulp1b66{gap:var(--ds-space-050,4px)}._11ko1txw>div{display:flex}\n._1e0c116y{display:inline-flex}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
